import { createPath } from 'history';
import { parse } from 'qs';
import { createElement, FC, Fragment, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { Prompt, Redirect, RouteComponentProps } from 'react-router';

import mergeUrlQuery from '../../../../utility/mergeUrlQuery';
import useAlertOnPageExit from '../../../../utilityHooks/useAlertOnPageExit';
import useScrollToTop from '../../../../utilityHooks/useScrollToTop';
import { context as HistoryContext } from '../../../context/history';
import { context as StateContext } from '../../../context/state';
import { getOrganization } from '../domain/helperFunctions';
import ScreenByStep from './ScreenByStep';

type Props = RouteComponentProps<{ projectId: string }>;

const ProjectEditingPage: FC<Props> = ({ match }) => {
  const { location, lastAccessedOrganization, availableOrganizations } = useContext(StateContext);
  const history = useContext(HistoryContext);
  const query = parse(location.search.slice(1));
  useScrollToTop(history.location.search);
  const { confirmAlert, setConfirmAlert } = useAlertOnPageExit(location.pathname);
  const organization = getOrganization(lastAccessedOrganization, availableOrganizations);

  return (
    <Fragment>
      {!query.org && organization ? (
        <Redirect to={createPath(mergeUrlQuery(history.location, { org: organization.id, step: query.step }))} />
      ) : (
        <Fragment>
          {query.step !== 'complete' && (
            <FormattedMessage id="prevent_navigation_dialog.text.pc">
              {(text: string) => <Prompt when={confirmAlert} message={`${text}`} />}
            </FormattedMessage>
          )}
          <ScreenByStep projectId={match.params.projectId} setConfirmAlert={setConfirmAlert} step={query.step} />
        </Fragment>
      )}
    </Fragment>
  );
};

export default ProjectEditingPage;
